import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    FormControl,
    MenuItem,
    Modal,
    Select,
    TextField
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ptBR } from "date-fns/locale";
import { useEffect, useState } from "react";
import { MIDIA_OPTIONS_CANAL_DIRETO } from "../../constants/midia";
import { UF_SIGLAS } from "../../constants/UF";
import { getCallStatusOptions } from "../../services/callCenterService";

const BudgetRequestModalFilterCanalDireto = ({open, onClose, setIsFilter, changeFilter, params}) => {

    const [statusOptions, setStatusOptions] = useState([]);
    
    const fetchOptions = async () => {
        const options = await getCallStatusOptions(4);
        setStatusOptions(options);
    };

    useEffect(() => {
        fetchOptions()
    }, [])

    const listaEstados = UF_SIGLAS;

    const midiaOptions = MIDIA_OPTIONS_CANAL_DIRETO;

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{ width: "35%", margin: "auto", overflow: "scroll" }}
        >
            <Card>
                <CardHeader title={"Filtros"} />
                <Divider />
                <CardContent style={{ display: "flex", flexDirection: "column" }}>
                    
                    <FormControl sx={{ m: 1 }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                            <DatePicker
                                label="Entrada"
                                inputFormat="dd/MM/yyyy"
                                value={params.check_in}
                                onChange={(date) => changeFilter("check_in", date)}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                            <DatePicker
                                label="Saída"
                                inputFormat="dd/MM/yyyy"
                                value={params.check_out}
                                onChange={(date) => changeFilter("check_out", date)}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Cliente"
                            onChange={(e) => changeFilter("client", e.target.value)}
                            value={params.client}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Operador"
                            onChange={(e) => changeFilter("clerk", e.target.value)}
                            value={params.clerk}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Agência"
                            onChange={(e) => changeFilter("agencia", e.target.value)}
                            value={params.agencia}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <Select
                            value={params.estado}
                            onChange={e => changeFilter("estado", e.target.value)}
                            required
                            sx={{
                                fontWeight: !params.estado ? 600 : 500,
                                fontFamily: 'Montserrat',
                            }}
                        >
                            <MenuItem
                                value={0}
                                sx={{
                                    fontWeight: 600,
                                    fontFamily: 'Montserrat',
                                }}
                            >
                                Selecione um estado
                            </MenuItem>
                            {listaEstados.map(estado => (
                                <MenuItem
                                    key={estado}
                                    value={estado}
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: 'Montserrat',
                                    }}
                                >
                                    {estado}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Executivo"
                            onChange={(e) => changeFilter("executivo", e.target.value)}
                            value={params.executivo}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <Select
                            value={params.motivo || 0}
                            onChange={(e) => changeFilter("motivo", e.target.value)}
                        >
                            <MenuItem value={0}>Selecione um motivo</MenuItem>
                            {statusOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.ds_status}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <Select
                            value={params.midia}
                            onChange={e => changeFilter("midia", e.target.value)}
                            required
                            sx={{
                                fontWeight: !params.midia ? 600 : 500,
                                fontFamily: 'Montserrat',
                            }}
                        >
                            <MenuItem
                                value={0}
                                sx={{
                                    fontWeight: 600,
                                    fontFamily: 'Montserrat',
                                }}
                            >
                                Selecione uma midia
                            </MenuItem>
                            {midiaOptions.map(midia => (
                                <MenuItem
                                    key={midia.id}
                                    value={midia.ds_midia}
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: 'Montserrat',
                                    }}
                                >
                                    {midia.ds_midia}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Observação"
                            multiline
                            onChange={(e) => changeFilter("observacao", e.target.value)}
                            value={params.observacao}
                        />
                    </FormControl>

                    <FormControl sx={{ m: 1 }}>
                        <TextField
                            label="Observações Gerais"
                            multiline
                            onChange={(e) => changeFilter("observacoes", e.target.value)}
                            value={params.observacoes}
                        />
                    </FormControl>

                    <Button
                        sx={{
                            m: 1,
                            color: "#fff",
                            fontWeight: 700,
                            textTransform: "capitalize",
                        }}
                        onClick={() => {
                            setIsFilter(false);
                        }}
                        color="tertiary"
                        variant="contained"
                    >
                        Filtrar Listagem
                    </Button>
                </CardContent>
            </Card>
        </Modal>
    );
};

export default BudgetRequestModalFilterCanalDireto;
